import { create } from "zustand";
import { CourseTema } from "../const/types";

type State = {
  myTema: CourseTema | null;
};

type Action = {
  setMyTema: (newTema: State["myTema"]) => void;
};

const useTemaMyCourses = create<State & Action>((set) => ({
  myTema: null,
  setMyTema: (newTema) => set(() => ({ myTema: newTema })),
}));

export default useTemaMyCourses;
